var map = {
	"./images/matthew-tan-178x178.jpg": 1778
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1777;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/advisors ^.*\/matthew\-tan\-178x178\.jpg$
// module id = 1777
// module chunks = 147